export default __webpack_public_path__ + "static/masterplan_2_V2-2d98b2a44b834390f2f957da2d88d441.jpg";